"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHiddenCatalogAbTest = void 0;
const types_1 = require("../../types");
const useListenForAbFlagChanges_1 = require("./useListenForAbFlagChanges");
const VWO_EXPERIMENT_KEY = 'homeCatalog';
const useHiddenCatalogAbTest = () => {
    const data = (0, useListenForAbFlagChanges_1.useListenForAbFlagChanges)(VWO_EXPERIMENT_KEY);
    const isHiddenCatalog = data === types_1.HiddenCatalogExperiment.HIDDEN;
    const isPartialCatalog = data === types_1.HiddenCatalogExperiment.PARTIAL;
    const isCatalogVisible = !data;
    return {
        isHiddenCatalog,
        isPartialCatalog,
        isCatalogVisible,
        data,
    };
};
exports.useHiddenCatalogAbTest = useHiddenCatalogAbTest;
